var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 232.11 192.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#acebe9;}.cls-2{fill:#4b4495;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M232,57.55l-15.66,75.17a3.28,3.28,0,0,1-3.22,2.62H83.79a3.28,3.28,0,0,1-3.22-2.62L64.9,57.55a3.3,3.3,0,0,1,3.22-4h160.7a3.3,3.3,0,0,1,3.22,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M223.92,149.17H72.39A4,4,0,0,1,68.53,146L41.81,19.76l-39-12A3.94,3.94,0,0,1,5.11.18L46.35,12.9a3.93,3.93,0,0,1,2.7,3L75.59,141.27H223.92a3.95,3.95,0,1,1,0,7.9Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 97.95,
    cy: 177.58,
    r: 14.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 184.82,
    cy: 177.58,
    r: 14.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127,85.88a6.37,6.37,0,1,1-6.37-6.37A6.37,6.37,0,0,1,127,85.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M176.61,85.88a6.26,6.26,0,1,1-6.25-6.25A6.26,6.26,0,0,1,176.61,85.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M153.34,113H138.56a1.54,1.54,0,1,1,0-3.08h14.78a1.54,1.54,0,0,1,0,3.08Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCart);
export default __webpack_public_path__ + "static/media/EmptyCart.7d1f849e09612a3b8d866e8b1009ab7f.svg";
export { ForwardRef as ReactComponent };